import { API_BASE } from '@/Module/Core/Constant';

export const SEARCH_API = {
  GET_SEARCH_RESULT: `${API_BASE}/Search/GetLessonSearch`,
};
